import { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import DateBar, { today, daysAgo } from '../components/DateBar';
import TopCustomers from '../components/TopCustomers';

export default function CustomersPage({ showToast }) {
  const [preset,    setPreset]    = useState(1);
  const [start,     setStart]     = useState(daysAgo(6));
  const [end,       setEnd]       = useState(today);
  const [loading,   setLoading]   = useState(false);
  const [customers, setCustomers] = useState([]);

  const fetchAll = useCallback(async (s, e) => {
    setLoading(true);
    try {
      setCustomers(await api.customers(s, e));
    } catch { showToast('Failed to fetch customers', 'error'); }
    finally { setLoading(false); }
  }, [showToast]);

  useEffect(() => { fetchAll(start, end); }, [start, end, fetchAll]);

  return (
    <div className="page-body">
      <div className="page-title">Customers</div>
      <div className="page-subtitle">Top customers ranked by revenue for the selected period</div>
      <DateBar start={start} end={end} preset={preset} setStart={setStart} setEnd={setEnd} setPreset={setPreset} loading={loading} />
      <TopCustomers data={customers} start={start} end={end} />
    </div>
  );
}
